import data from '../../resources/data.json';
import helpers from '../helpers';

const $window = $(window);
const $container = $('.test-inc');
const $start = $('.js-test-start');
const $question = $('.js-test-questions');
const $result = $('.js-test-result');

const $actual = $('.js-actual');
const $total = $('.js-total');
const $questionText = $('.js-question');
const $questionWrapper = $('.js-question-wrapper');
const $questionImage = $('.js-question-image');
const $checkboxes = $('.js-checkbox');
const $answers = $('.js-question-answer');
const $next = $('.js-next-button');

const $resultWrapper = $('.js-result-wrapper');
const $resultDisclamer = $('.js-disclaimer');
const $resultText = $('.js-result');
const $resultDescription = $('.js-result-description');
const $resultImage = $('.js-result-image');

const questions = data.questions;
const results = data.results;

let questionNumber = 1;
let testResults = [
	{
		name: 'a',
		value: 0,
	},
	{
		name: 'b',
		value: 0,
	},
];

let choose = false;
let preloadImageComplite = false;

const clearCheckboxes = () => {
	$checkboxes.each((i, check) => {
		let $check = $(check);

		$check.prop('checked', false);
	});
};

const searchSpecialSymbols = [
	['&nbsp;', ' '],
	['&thinsp;', ' '],
	['&laquo;', '«'],
	['&raquo;', '»'],
	['&quot;', '"'],
	['&lt;', '<'],
	['&gt;', '>'],
	['&lsquo;', '‘'],
	['&rsquo;', "'"],
	['&ndash;', '–'],
	['&mdash;', '—'],
	['&amp;', '&'],
	['&#8209;', '‑'],
	['<br>', ''],
];

const sendPostMessages = (actionName) => {
	if (typeof parent === 'undefined') {
		return;
	}

	if (actionName === 'result' || actionName === 'restart') {
		parent.postMessage('scrollTop', '*');
	}

	const heightMessage = () => {
		const testHeight = `height=${$container.height()}`;

		parent.postMessage(testHeight, '*');
	};

	heightMessage();

	setTimeout(heightMessage, 100);
};

const replaceSymbols = (text) => {
	for (let i = 0; i < searchSpecialSymbols.length; i++) {
		let re = new RegExp(`(${searchSpecialSymbols[i][0]})`, 'g');

		text = text.replace(re, searchSpecialSymbols[i][1]).replace(/\s+/g, ' ').trim();
	}

	return text;
};

const getAnswer = () => {
	let question = questions.filter((item) => {
		return +item.id === +questionNumber;
	})[0];

	let answerID = $question.find('input:checked').closest('.js-question-answer').data('answer');

	let answer = question.answers.filter((item) => {
		return +item.id === +answerID;
	})[0].type;

	testResults.filter((item) => {
		return item.name === answer;
	})[0].value += 1;

	$next.addClass('js-disabled');

	helpers.$document.trigger('analytics-test-question-answer', [$actual.text(), $answers.filter(`[data-answer="${answerID}"]`).find('.js-answer-text').text()]);
};

export const getResult = () => {
	return (
		[...testResults].sort((a, b) => {
			if (a.value < b.value) {
				return 1;
			}
			if (a.value > b.value) {
				return -1;
			}

			return 0;
		})[0].name
	);
};

const setResultContent = () => {
	getAnswer();

	let resultValue = getResult();

	let result = results.filter((item) => {
		return item.id === resultValue;
	})[0];

	$resultDisclamer.text(replaceSymbols(result.disclaimer));
	$resultText.text(replaceSymbols(result.title));
	$resultDescription.text(replaceSymbols(result.text));
	$resultImage.attr('src', `./images/test/${result.image}.jpg?v=2`);

	helpers.$document.trigger('analytics-test-finish', [$resultText.text()]);
};

const preloadImage = () => {
	if (preloadImageComplite) {
		return;
	}

	let image = new Image();

	if (questionNumber === questions.length) {
		image.src = './images/test/physics.jpg?v=2';
		preloadImageComplite = true;
	} else {
		image.src = `./images/test/${questionNumber + 1}.jpg?v=2`;
	}
};

const setQuestionContent = (start) => {
	let number;

	start ? number = start : number = questionNumber; // eslint-disable-line

	clearCheckboxes();

	let question = questions.filter((item) => {
		return item.id === number;
	})[0];

	if (number === 1) {
		$total.text(questions.length);
	}

	$actual.text(number);

	$questionText.text(replaceSymbols(question.text));
	$questionImage.attr('src', `./images/test/${number}.jpg?v=2`);

	$answers.each((i, answer) => {
		let $answer = $(answer);
		let answerID = $answer.data('answer');

		let answerText = question.answers.filter((item) => {
			return +item.id === +answerID;
		})[0].text;

		$answer.find('.js-answer-text').text(replaceSymbols(answerText));
	});

	choose = false;

	$answers.on('click', () => {
		$next.removeClass('js-disabled');
		choose = true;
	});

	helpers.$document.trigger('analytics-test-question-show', [number, $questionText.text()]);
};

const clearQuestionContent = () => {
	helpers.$document.trigger('analytics-test-resume');
	helpers.$document.trigger('analytics-test-start');

	setQuestionContent(1);

	questionNumber = 1;
	testResults = [
		{
			name: 'a',
			value: 0,
		},
		{
			name: 'b',
			value: 0,
		},
	];

	$question
		.data('question', '1')
		.attr('data-question', '1');

	choose = false;
};

const nextQuestion = () => {
	getAnswer();

	if (questions.length > questionNumber) {
		questionNumber++;
	}

	$question
		.data('question', questionNumber)
		.attr('data-question', questionNumber);
};

const setTestPage = (type) => {
	switch (type) {
		case 'next':
			nextQuestion();
			setQuestionContent();
			preloadImage();
			sendPostMessages('next');

			break;

		case 'result':
			window.scrollTo(0, 0);
			$start.addClass('is-hidden');
			$question.addClass('is-hidden');
			$result.removeClass('is-hidden');
			setResultContent();
			sendPostMessages('result');

			break;

		case 'restart':
			window.scrollTo(0, 0);
			$result.addClass('is-hidden');
			$start.removeClass('is-hidden');
			$question.removeClass('is-hidden');
			clearQuestionContent();
			sendPostMessages('restart');

			break;

		default:
			break;
	}
};

const testAnimation = (animation = 'start') => {
	gsap.killTweensOf([$start, $questionWrapper, $questionImage, $resultWrapper, $resultImage]);
	gsap.set([$start, $questionWrapper, $questionImage, $resultWrapper, $resultImage], {clearProps: 'all'});

	let tl = gsap.timeline();

	switch (animation) {
		case 'start':
			tl
				.from($start, {
					autoAlpha: 0,
					y: 30,
					duration: 0.4,
					clearProps: 'all',
				}, 0.5)
				.from($questionWrapper, {
					autoAlpha: 0,
					x: -30,
					duration: 0.4,
					clearProps: 'all',
				}, 0.5)
				.from($questionImage, {
					autoAlpha: 0,
					x: 30,
					duration: 0.4,
					clearProps: 'all',
				}, 0.5);

			break;

		case 'next':
			tl
				.to($questionWrapper, {
					keyframes: [
						{
							onStart() {
							},
							onComplete() {
								setTestPage(animation);
							},
							autoAlpha: 0,
							x: -30,
							duration: 0.4,
						},
						{
							autoAlpha: 1,
							x: 0,
							duration: 0.4,
							clearProps: 'all',
						},
					],
				}, 0)
				.to($questionImage, {
					keyframes: [
						{
							autoAlpha: 0,
							x: 30,
							duration: 0.4,
						},
						{
							autoAlpha: 1,
							x: 0,
							duration: 0.4,
							clearProps: 'all',
						},
					],
				}, 0);

			break;

		case 'result':
			tl
				.to($start, {
					onComplete() {
						setTestPage(animation);
					},
					autoAlpha: 0,
					y: -30,
					duration: 0.4,
					clearProps: 'all',
				}, 0)
				.to($questionWrapper, {
					autoAlpha: 0,
					x: -30,
					duration: 0.4,
					clearProps: 'all',
				}, 0)
				.to($questionImage, {
					autoAlpha: 0,
					x: 30,
					duration: 0.4,
					clearProps: 'all',
				}, 0)
				.from($resultWrapper, {
					autoAlpha: 0,
					x: -30,
					duration: 0.4,
					clearProps: 'all',
				}, 0.4)
				.from($resultImage, {
					autoAlpha: 0,
					x: 30,
					duration: 0.4,
					clearProps: 'all',
				}, 0.4);

			break;

		case 'restart':
			tl
				.to($resultWrapper, {
					onComplete() {
						setTestPage(animation);
					},
					autoAlpha: 0,
					x: -30,
					duration: 0.4,
					clearProps: 'all',
				}, 0)
				.to($resultImage, {
					autoAlpha: 0,
					x: 30,
					duration: 0.4,
					clearProps: 'all',
				}, 0)
				.from($start, {
					autoAlpha: 0,
					y: 30,
					duration: 0.4,
					clearProps: 'all',
				}, 0.4)
				.from($questionWrapper, {
					autoAlpha: 0,
					x: -30,
					duration: 0.4,
					clearProps: 'all',
				}, 0.4)
				.from($questionImage, {
					autoAlpha: 0,
					x: 30,
					duration: 0.4,
					clearProps: 'all',
				}, 0.4);

			break;

		default:
			break;
	}
};

const testInit = () => {
	helpers.$document.trigger('analytics-test-start');

	setQuestionContent();
	preloadImage();

	if (innerWidth >= 1200) {
		testAnimation();
	}

	sendPostMessages();

	const $buttons = $('.js-button');

	$window.on('resize', sendPostMessages);

	$buttons.on('click', (e) => {
		let type = $(e.currentTarget).data('event');

		if (type === 'next' && questions.length === questionNumber) {
			type = 'result';
		}

		if (choose) {
			if (innerWidth < 1200) {
				setTestPage(type);
			} else {
				testAnimation(type);
			}
		}
	});
};

testInit();
